export { default as FreeLoader } from './FreeLoader.vue';
